import { addStyles } from "@lib/setupRoot";
import { createSignal, onMount } from "solid-js";
import stylesheetMain from "../styles/icu/modal.css?inline";

declare global {
  interface Window {
    upcsPickedArray: string[];
    setEyeglassesElements?: (_inputElm: HTMLInputElement, _submitBtn: HTMLButtonElement) => void;
  }
}

export function AppIcuPickerT3312() {
  const [isAppVisible, setIsAppVisible] = createSignal(true);
  const upcsPicked = new Set<string>();
  let inputElm: HTMLInputElement | undefined = undefined;
  let submitBtn: HTMLButtonElement | undefined = undefined;

  onMount(() => {
    addStyles(stylesheetMain);

    window.setEyeglassesElements = (_inputElm: HTMLInputElement, _submitBtn: HTMLButtonElement) => {
      inputElm = _inputElm;
      submitBtn = _submitBtn;
    };
  });

  function handleSubmit() {
    const upcsPickedArray = Array.from(upcsPicked);
    window.upcsPickedArray = upcsPickedArray; // Expose the picked UPCs globally for debugging
    if (inputElm && submitBtn) {
      for (const upc of upcsPickedArray) {
        inputElm.value = upc;
        submitBtn.click();
      }
    }

    setIsAppVisible(() => false);

    // upcsPicked.forEach((upc) => {
    //   inputText(
    //     "Scan each out of stock item using your Store specific Scan Guide for the ICU CORE SIDECAP Fixture  ",
    //     upc,
    //     {
    //       clickSubmit: true,
    //       isRequireVisible: true,
    //     }
    //   );
    //   setIsAppVisible(() => false);
    // });
  }

  return (
    <div classList={{ "visually-hidden": !isAppVisible() }}>
      <div id="modal-icu-upc-picker">
        <div id="grids-container">
          <div class="front-panel-flex-container">
            <ul class="panel">
              <ListItem upc={"078041242734"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243519"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243571"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243632"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041073062"} upcsPicked={upcsPicked}></ListItem>

              <ListItem upc={"078041242727"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243502"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243564"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243625"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041050241"} upcsPicked={upcsPicked}></ListItem>

              <ListItem upc={"078041242710"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243496"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243557"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243618"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041129233"} upcsPicked={upcsPicked}></ListItem>

              <ListItem upc={"078041242703"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243489"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243540"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243601"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041227755"} upcsPicked={upcsPicked}></ListItem>

              <ListItem upc={"078041242697"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243472"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243533"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041243595"} upcsPicked={upcsPicked}></ListItem>
              <ListItem upc={"078041227762"} upcsPicked={upcsPicked}></ListItem>
            </ul>
          </div>
        </div>
        <button type="button" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
}

interface ListItemProps {
  upc: string;
  upcsPicked: Set<string>;
}

function ListItem(props: ListItemProps) {
  const [isSelected, setIsSelected] = createSignal(false);

  function handleClick() {
    setIsSelected((prevSelected) => !prevSelected);
    if (isSelected()) {
      props.upcsPicked.add(props.upc);
    } else {
      props.upcsPicked.delete(props.upc);
    }
  }

  return (
    <li onClick={handleClick} classList={{ selected: isSelected() }} data-upc={props.upc}></li>
  );
}
